<template>
  <div id="group_create" class="fleet-form-main">
      <div :class="`loader${loaderClass}`" v-show="loading">
      </div>
      <div id="page-content-wrapper" class="admin-content-area">
          <template v-if="cantAccessPage === true">
              <div class="page-name">
                  <span class="page-title" id="groupHeader" v-if="$route.params.id > 0">Update Customer Order Price</span>
                  <span class="page-title" id="groupHeader" v-else>Add Customer Order Price</span>
                  <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackList" >
                      <i class="fp-back"> </i> Back
                  </button>
              </div>
              <div class="container-fluid">
                  <div class="admin-page-content group-crud">
                      <section class="internal-container border-top-table-fl">
                          <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="GroupForm">
                              <div class="form-row">
                                  <div class="col-sm-6 form-group">
                                      <label class="control-label require" for="price_type">Price Type:</label>
                                      <input type="text" class="form-control" v-model="price_type" id="price_type" placeholder="Enter Price Type" name="price_type">
                                      <div class="field-error">{{price_type_error_msg}}</div>
                                  </div>
                                  <div class="col-sm-6 form-group">
                                      <label class="control-label require" for="price_name">Price Name:</label>
                                      <input type="text" class="form-control" v-model="price_name" id="price_name" placeholder="Enter Price Name" name="price_name">
                                  </div>
                              </div>
                              <div class="form-row">
                                <div class="col-sm-6 form-group">
                                      <label class="control-label require" for="price">Price:</label>
                                      <input type="number" class="form-control" v-model="price" id="price" placeholder="Enter Price" name="price">
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                      <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                      <strong id="errorMsg" class="field-error"></strong>
                                  </div>
                              </div>
                              <div class="btn-groups">
                                  <button type="submit" id="createGroupBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreatePrice" >
                                  <i class="fp-reload"> </i>  Update
                                  </button>
                                  <button type="submit" id="createGroupBtn" v-else class="btn btn-primary" v-on:click.prevent="CreatePrice" >
                                  <i class="fp-save"> </i>  Save
                                  </button>
                                  <button type="submit" id="createAndContinueGroupBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreatePrice(flag='Save and Continue')" >
                                  <i class="fp-save-continue"> </i>  Save and Continue
                                  </button>
                                  <button type="submit" id="cancelGroupBtn" class="btn btn-tertiary" v-on:click.prevent="BackList">
                                  <i class="fp-close"> </i>  Cancel
                                  </button>
                              </div>
                          </form>
                      </section>
                  </div>
              </div>
          </template>
          <template v-else-if="cantAccessPage === false">
              <div class="container-fluid">
                  <div class="bg-white text-center">
                      <h1>
                          Oops!</h1>
                      <h2>
                          403 </h2>
                      <div class="error-details">
                          Sorry!, You don't have permission to access this page.
                      </div>
                  </div>
              </div>
          </template>
          <template v-else>
              <loading-content></loading-content>
          </template>
          <app-footer></app-footer>
      </div>
  </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins'
import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);

export default {
name: "CustomerOrderPricingCreate",
components: {
      appFooter: () => import('@/components/Footer')
  },
metaInfo() {
    return {title: (this.$route.params.id > 0)? "Update Customer Order Pricing | " +process.env.COPYRIGHT_NAME : "Create Customer Order Pricing | " +process.env.COPYRIGHT_NAME}
},
mixins:[commonMixins],
data: () => ({
   permissions: [],
  cantAccessPage: "",
  price: 0,
  price_type: "",
  price_name: "",
  price_type_error_msg: "",

  checkboxValue: "",
  checked: "",
  loading:false,
  name_error_msg: ""
}),
created: function() {

},
watch: {

    //check permission change
    permissions: function (permissions) {
        var self = this;
        if (permissions.length > 0) {
            for (var i = 0; i < permissions.length; i++) {
                if (permissions[i].name == 'add_customer_order_price') {
                    self.cantAccessPage = true;                  }
            }
        }

    }

 },
mounted: function() {
      var self = this;
      self.checkboxValue = 0;
      self.getPermissions();
      setTimeout(function () {
              var path = window.location.pathname;
              var segments = path.split("/");

              if (segments[3]) {
                  self.loadPrice();
              }
          }, 100);
},
methods: {

  BackList(){
      var self = this;
      self.$router.push("/customer-order-pricing/list");
  },

  CreatePrice(flag) {
    var self = this;

    self.price_type = self.price_type.trim();

    self.price_type_error_msg = "";

    if (!self.price_type || self.price_type == null || self.price_type == "") {
      self.price_type_error_msg = "Price Type Required.";
    } else{
      self.price_type_error_msg = "";
    }

    if (self.price_type_error_msg == "") {

          self.loading = true;
          var path = window.location.pathname;
          var segments = path.split("/");
          if (segments[3])
          {
              $("#createGroupBtn").val("Updating ...");
              $("#createGroupBtn").prop("disabled", true);
              $("#cancelGroupBtn").prop("disabled",true);
          } else {
              if (flag == "Save and Continue") {

                  $("#createAndContinueGroupBtn").val("Saving ...");
                  $("#createGroupBtn").prop("disabled", true);
                  $("#createAndContinueGroupBtn").prop("disabled", true);
                  $("#cancelGroupBtn").prop("disabled",true);

              }else{

                  $("#createGroupBtn").val("Saving ...");
                  $("#createGroupBtn").prop("disabled", true);
                  $("#createAndContinueGroupBtn").prop("disabled", true);
                  $("#cancelGroupBtn").prop("disabled",true);
              }

          }

          $.ajax({
              url: process.env.ROOT_API + "/customer-order-pricing/create",
              type: "POST",
              data: {
                price_type: self.price_type,
                price: self.price,
                price_name: self.price_name,
                id: segments[3]},
              headers: {
                  Accept: "application/json",
                  "Access-Control-Allow-Origin": "*",
                  "Authorization": "Bearer " + localStorage.getItem("tkn"),
                  "Access-Control-Allow-Headers":
                      "Origin, Content-Type, Authorization,X-Requested-With",
                  "Cache-Control": "no-cache"
              },
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  if (segments[3])
                  {
                      $("#createGroupBtn").val("Update");
                      $("#createGroupBtn").prop("disabled", false);
                      $("#cancelGroupBtn").prop("disabled",false);
                  } else {
                      if (flag == "Save and Continue") {

                          $("#createAndContinueGroupBtn").val("Save and Continue");
                          $("#createGroupBtn").prop("disabled", false);
                          $("#createAndContinueGroupBtn").prop("disabled", false);
                          $("#cancelGroupBtn").prop("disabled",false);

                      }else{

                          $("#createGroupBtn").val("Save");
                          $("#createGroupBtn").prop("disabled", false);
                          $("#createAndContinueGroupBtn").prop("disabled", false);
                          $("#cancelGroupBtn").prop("disabled",false);

                      }
                  }
                  if (data.status == "success") {

                      if (flag == "Save and Continue") {

                          $("#GroupForm").trigger("reset");
                          self.price =  0;
                          self.price_type =  "";
                          self.price_name = "";
                      }else{
                          self.$router.push("/customer-order-pricing/list");
                      }

                  } else {
                      if (data.content.length > 0) {
                          var err = "";
                          for (var i = 0; i < data.content.length; i++) {
                              err += data.content[i] + "<br>";
                          }
                          $("#errorMsg").html(err);
                          $(".alert-warning").toggleClass("show");
                          setTimeout(function () {
                              $(".alert-warning").removeClass("show");
                              $(".alert-warning").addClass("hide");
                          }, 10000);
                      }
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  if (segments[3])
                  {
                      $("#createGroupBtn").val("Update");
                      $("#createGroupBtn").prop("disabled", false);
                      $("#cancelGroupBtn").prop("disabled",false);
                  } else {
                      if (flag == "Save and Continue") {

                          $("#GroupForm").trigger("reset");


                          $("#createAndContinueGroupBtn").val("Save and Continue");
                          $("#createGroupBtn").prop("disabled", false);
                          $("#createAndContinueGroupBtn").prop("disabled", false);
                          $("#cancelGroupBtn").prop("disabled",false);

                      }else{

                          $("#createGroupBtn").val("Save");
                          $("#createGroupBtn").prop("disabled", false);
                          $("#createAndContinueGroupBtn").prop("disabled", false);
                          $("#cancelGroupBtn").prop("disabled",false);

                      }
                  }
                  self.generateStatusCodeMessage(jqXHR,true,'customer-order-prices-create')
              }
          });
    }else{
          self.errorValidationFocus();
    }
  },

  loadPrice() {
      var path = window.location.pathname;
      var segments = path.split("/");
      var self = this;
      self.loading = true;
      $.ajax({
          url: process.env.ROOT_API + "/customer-order-pricing/" + segments[3],
          type: "GET",
          headers: {
              Accept: "application/json",
              "Access-Control-Allow-Origin": "*",
              "Authorization": "Bearer " + localStorage.getItem("tkn"),
              "Access-Control-Allow-Headers":
                  "Origin, Content-Type, Authorization,X-Requested-With",
              "Cache-Control": "no-cache"
          },
          dataType: "json",
          success: function (data) {
              self.loading = false;
              console.log(data);
              if (data.status == "success") {
                  self.price_type = data.content.type;
                  self.price = data.content.price;
                  self.price_name = data.content.name;
              }
          },
          error: function (jqXHR, exception) {
              self.loading = false;
              self.generateStatusCodeMessage(jqXHR,false,'group-by-id-load')
          }
      });
  },
}
};
</script>



// WEBPACK FOOTER //
// src/components/asset/CustomerOrderPricingCreate.vue